import React from 'react';
import './ABSLabelValueVertical.less';
import { IABSLabelValueData } from './interface';

export interface IABSLabelValueVerticalProps {
  item: IABSLabelValueData;
}

class ABSLabelValueVertical extends React.Component<IABSLabelValueVerticalProps> {

  renderContent() {
    const { item } = this.props;
    const { contentStyle, content = '' } = item;
    return <div className="abs-label-value-vertical-content" style={contentStyle}>{content}</div>;
  }

  render() {
    const { item } = this.props;
    const { title } = item;
    return (
      <div className="abs-label-value-vertical">
        {title ? <p className="abs-label-value-vertical-title">{title}</p> : null} 
        {this.renderContent()}
      </div>
    );
  }
}
export { IABSLabelValueData };
export default ABSLabelValueVertical;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSLabelValueList/ABSLabelValueVertical.tsx